import { useEnvJSON } from "../../../configurator/renderer/customContext/EnvContext";

import { useState } from "react";
import { JSX } from "react";

import BuildIcon from "@mui/icons-material/Build";
import { Drawer, Fab, Stack, Typography } from "@mui/material";

import DevAdministrationAreaIndicator from "./DevAdministrationAreaIndicator";
import DevErrorTester from "./DevErrorTester";
import DevMaintenanceModeButton from "./DevMaintenanceModeButton";
import DevOnboardingStatusIndicator from "./DevOnboardingStatusIndicator";

export function DevToolsDrawer(): JSX.Element | null {
  const [isOpen, setIsOpen] = useState(false);
  const { envJSON } = useEnvJSON();

  if (envJSON?.APP_ENV !== "dev") {
    return null;
  }

  return (
    <>
      <Drawer
        variant="persistent"
        anchor="left"
        open={isOpen}
        slotProps={{ paper: { sx: { width: "auto" } } }}
      >
        <Stack spacing={2} p={2}>
          <Typography variant="subtitle2">Dev tools</Typography>
          <DevOnboardingStatusIndicator />
          <DevAdministrationAreaIndicator />
          <DevErrorTester />
          <DevMaintenanceModeButton />
        </Stack>
      </Drawer>

      <Fab
        color="warning"
        aria-label="Dev tools"
        onClick={() => setIsOpen((prev) => !prev)}
        sx={{
          position: "fixed",
          bottom: 48,
          left: 48,
          opacity: ".5",
          zIndex: (theme) => theme.zIndex.drawer + 1,
        }}
      >
        <BuildIcon />
      </Fab>
    </>
  );
}
